import React from 'react';
import './faq.scss'

const Faq = () => {
    return (
        <section id="faq">
            <div className="container">
                <div className="faq">
                    {/*<h1>Frequently Asked Questions</h1>*/}
                    <div className="faq--group">

                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faq;